export default "__VITE_ASSET___32Pxna6__"